export default __webpack_public_path__ + "static/Texta-Regular-webfont-0482a960a11312e3ada934ba4bf4670f.woff2";